import addFavorite from './addFavorite'
import removeFavorite from './removeFavorite'

export default {addFavorite, removeFavorite}
